import MainApi from "@api/main";
import { isForeignCurrency, isHKOrTWClient, isTWClient, isHKClient } from "@utils/assist";
import {
  INIT_USER_INFO,
  INIT_USER_PERMISSION,
  CLIENT_VERIFY_INFO,
  CLIENT_FADADA_VERIFY_INFO,
  IS_CHILD_ACCOUNT,
  CHILD_ACCOUNT_ERR_MSG,
  NOW_SERVE_TIME
} from "../mutationTypes.js";

import {
  VERIFY_STATUS_PASS,
  VERIFY_STATUS_REFUSE,
  VERIFY_STATUS_REFUSE_OVERSEA
} from "@utils/constants";

const state = {
  userInfo: {
    client: {},
    user: {},
    verification: {}
  },
  permission: {
    privilege: {
      list: [],
      user: {}
    },
    setting: {}
  },
  isMiniProgram: window.__xm_wx.isMiniProgram,
  fadadaVerification: {},
  isChildAccount: false,
  childAccountErrMsg: "",
  nowServeTime: "",
  // 客户是否激活，可以请求crm数据
  isClientActive: false,
};

const getters = {
  // 是否是阿里客户可购买
  isCanBuy(state) {
    return state.userInfo.could_buy;
  },
  // 非人民币货币符号会在多个页面有自己的判断
  isForeignCurrency(state) {
    return isForeignCurrency(state.userInfo.client.currency_id);
  },
  // 是否是台湾或者香港客户
  isTaiwanClient(state) {
    return isHKOrTWClient(state.userInfo.client.use_zone);
  },
  isTWClient(state) {
    return isTWClient(state.userInfo.client.use_zone);
  },
  isHKClient(state) {
    return isHKClient(state.userInfo.client.use_zone);
  },
  // 货币符号
  currency(state) {
    return state.userInfo.client.currency_label;
  },
  // 验证状态
  verifyStatus(state) {
    return state.userInfo.verification.status;
  },
  // 验证不通过原因
  verifyErrorMessage(state) {
    return state.userInfo.verification.message;
  },
  // 是否在小程序中访问
  isMiniProgram(state) {
    return state.isMiniProgram;
  },
  // 是否是海外客户
  isOversea(state) {
    return state.userInfo.client.is_oversea == 1;
  },
  //企业认证类型
  verifyType(state) {
    return state.userInfo.verification.verification_type;
  },
  //客户企业认证跳转页
  authPath(state) {
    return state.userInfo.verification.verification_type === 1
      ? "/mainlandAuth"
      : "/auth";
  },
  // 法大大审核状态
  fadadaVerifyStatus(state) {
    return state.fadadaVerification.fadada_status;
  },
  // 法大大平台链接
  fadadaUrl(state) {
    return state.fadadaVerification.fadada_url;
  },
  // 未认证状态
  noneVerifyStatus(state) {
    return state.userInfo.verification.status !== VERIFY_STATUS_PASS;
  },
  // 认证拒绝
  refuseVerifyStatus(state) {
    return (
      state.userInfo.verification.status === VERIFY_STATUS_REFUSE ||
      state.userInfo.verification.status === VERIFY_STATUS_REFUSE_OVERSEA
    );
  },
  // 是否是ali客户
  isAliUser(state) {
    return Boolean(state.userInfo.client.ali_cgs) !== false;
  },
  // 是否是主账号
  isAdmin(state) {
    return state.userInfo.user.is_admin;
  },
  // ali订单开票隐藏
  aliOrderInvoiceHide(state) {
    return (
      state.nowServeTime <= new Date("2021-02-01 00:00:00") //2021-02-01之后ali订单允许开票
    );
  }
};

const actions = {
  fetchUserInfo({ commit }) {
    return MainApi.fetchUserInfo().then(data => {
      commit(INIT_USER_INFO, data);
      return data;
    });
  },
  fetchPermission({ commit }) {
    MainApi.fetchPermission().then(data => {
      const { privilege, setting } = data;
      commit(INIT_USER_PERMISSION, {
        privilege,
        setting
      });
    });
  },
  saveUserSetttingLanguage(store, params) {
    return MainApi.saveUserSetting(params);
  },
  fetchClientVerifyInfo({ commit }, params) {
    MainApi.fetchClientVerifyInfo(params).then(data => {
      commit(CLIENT_VERIFY_INFO, data);
    });
  },
  fetchFadadaVerifyInfo({ commit }) {
    MainApi.fetchFadadaVerifyInfo()
      .then(data => {
        commit(CLIENT_FADADA_VERIFY_INFO, data);
      })
      .catch(err => {
        if (err.code === -1) {
          commit(IS_CHILD_ACCOUNT, true);
          commit(CHILD_ACCOUNT_ERR_MSG, err.msg);
        }
      });
  },
  fetchGIDMemberIDList({ commit }) {
    MainApi.fetchGIDMemberIDList()
        .then(data => {
          commit(CLIENT_FADADA_VERIFY_INFO, data);
        })
        .catch(err => {
          if (err.code === -1) {
            commit(IS_CHILD_ACCOUNT, true);
            commit(CHILD_ACCOUNT_ERR_MSG, err.msg);
          }
        });
  },
  getServerDate({ commit }) {
    let xhr = window.XMLHttpRequest
      ? new window.XMLHttpRequest()
      : new window.ActiveXObject("Microsoft");

    xhr.open("GET", `/home?t=${new Date().getTime()}`, true);
    xhr.send(null);
    xhr.onreadystatechange = async () => {
      if (xhr.readyState == 2) {
        commit(NOW_SERVE_TIME, new Date(xhr.getResponseHeader("Date")));
      }
    };
  }
};

const mutations = {
  [INIT_USER_INFO](state, data) {
    state.userInfo = data;
    state.isClientActive = data.client.client_status || false
  },
  [INIT_USER_PERMISSION](state, data) {
    state.permission = data;
  },
  [CLIENT_VERIFY_INFO](state, data) {
    state.userInfo.verification = data;
  },
  [CLIENT_FADADA_VERIFY_INFO](state, data) {
    state.fadadaVerification = data;
  },
  [IS_CHILD_ACCOUNT](state, data) {
    state.isChildAccount = data;
  },
  [CHILD_ACCOUNT_ERR_MSG](state, data) {
    state.childAccountErrMsg = data;
  },
  [NOW_SERVE_TIME](state, data) {
    state.nowServeTime = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
